import { useQuery } from "@tanstack/react-query";
import { useSurveyListOptions } from "./surveys.api";
import SurveyCard from "./components/SurveyCard";
import PageWrapper from "@/components/PageWrapper";
import NoData from "@/components/common/NoData";
import { ClipboardList } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function SurveyListPage() {
  const { data: surveys, isLoading } = useQuery(useSurveyListOptions());
  const { t } = useTranslation();

  return (
    <PageWrapper backPath="/">
      <div className="container pt-4 pb-6 flex flex-col min-h-[calc(var(--tg-viewport-height,100vh)-var(--safe-area-inset-top,0px)-var(--safe-area-inset-bottom,0px))]">
        <h1 className="text-xl font-bold text-white leading-130 mb-4">
          {t("surveys") || "So'rovnomalar"}
        </h1>

        {isLoading ? (
          <div className="grid gap-3">
            {Array.from({ length: 6 }).map((_, idx) => (
              <div
                className="rounded-xl border border-white/[0.08] bg-gray-4 p-3"
                key={idx}
              >
                <div className="flex items-center gap-3">
                  <div className="size-11 rounded-full skeleton shrink-0" />
                  <div className="flex-1 min-w-0 flex flex-col gap-2">
                    <div className="skeleton h-4 w-3/4 rounded" />
                    <div className="skeleton h-1.5 w-full rounded-full" />
                  </div>
                  <div className="size-8 rounded-full skeleton shrink-0" />
                </div>
              </div>
            ))}
          </div>
        ) : surveys && surveys.length > 0 ? (
          <div className="grid gap-3">
            {[...surveys]
              .sort((a, b) => Number(a.is_completed) - Number(b.is_completed))
              .map((survey) => (
                <SurveyCard key={survey.id} survey={survey} />
              ))}
          </div>
        ) : (
          <div className="flex-1 flex-center min-h-[60vh]">
            <NoData
              title={t("surveys_not_found") || "So'rovnomalar topilmadi"}
              description={
                t("surveys_not_found_description") ||
                "Hozircha so'rovnomalar yo'q. Tez orada yangi so'rovnomalar qo'shiladi."
              }
              image={<ClipboardList width={48} height={48} className="text-gray-1" />}
              headerClassName="bg-white/08 rounded-full"
            />
          </div>
        )}
      </div>
    </PageWrapper>
  );
}
